import React from 'react';
import { Content, Main, Wrapper } from '../../styles';
import { ReactComponent as Alert } from '../../../../assets/icons/alert.svg';
import { useSelector } from 'react-redux';

const ContactError: React.FC = () => {
  const errorMessage = useSelector(
    (state: ApplicationState) =>
      state.config.mensagemCpfNaoEncontrado.toString().trim() ||
      `Não conseguimos encontrar nenhum contato seu em nossa base de dados. Fale conosco através de um dos meios listados abaixo para que posssamos te ajudar a resolver isso.`
  );

  return (
    <Wrapper>
      <Content>
        <>
          <Main>
            <div>
              <Alert />
            </div>
            <h2>Ops! Não encontramos o seu contato</h2>
            <p>{errorMessage}</p>
          </Main>
        </>
      </Content>
    </Wrapper>
  );
};

export default ContactError;
